import 'rxjs/add/operator/map';

import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ToastController,
} from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
export class LoadingAlertProvider {
  loader: any;

  constructor(
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private actionSheetCtrl: ActionSheetController
  ) {
    console.log('Hello LoadingAlertProvider Provider');
  }

  showLoader() {
    this.showLoaderWithText(null);
  }

  showLoaderWithText(text) {
    this.dismissLoader();
    this.loader = this.loadingCtrl.create({
      content: text,
    });
    this.loader.present();
  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
      this.loader = null;
    }
  }

  presentAlert(title, subtitle) {
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: subtitle,
      buttons: ['Ok'],
    });
    alert.present();
  }

  showToastAlert(message) {
    this.showToast(message, 'alert');
  }

  showToastConfirmation(message) {
    this.showToast(message, 'confirm');
  }

  showToast(message, cssClass) {
    const duration = 5000;
    let toast = this.toastCtrl.create({
      message: message,
      position: 'top',
      cssClass: cssClass,
      duration,
    });
    toast.present();
  }

  showConfirmationDialog(
    message: string,
    buttonText: string,
    callback: Function,
    cancelCallback?: Function
  ) {
    let actionSheet = this.actionSheetCtrl.create({
      title: message,
      buttons: [
        {
          text: buttonText,
          handler: () => {
            callback();
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            if (cancelCallback) {
              cancelCallback();
            }
          },
        },
      ],
    });
    actionSheet.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading-alert/loading-alert.ts